export { buttonVariables as buttonContentVariables } from './buttonVariables';
